import { Button, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useModalStore } from '../../store/ModalStore'
import './ContactUs.css'
import { MODAL_STATE } from '../../types/modals'
import React from 'react'

const { Title } = Typography

const ContactUs = () => {
    const { t } = useTranslation()
    const { openModal } = useModalStore()

    return (
        <div className="contact-us">
            <Title className="title any-questions">
                {t('about.contactUs.title')}
            </Title>
            <Button
                type="primary"
                size="large"
                className="any-questions-button"
                onClick={() => openModal(MODAL_STATE.CONTACT_US)}
            >
                {t('about.contactUs.contactUs')}
            </Button>
        </div>
    )
}

export default ContactUs
